import Utils from '@/utils/utils';
/**
 * 链接map
 */
const urlMap = new Map([
  [
    'ar',
    new Map([
      ['homepage', 'https://ar.hitpaw.com/'],
      ['editorPage', 'https://ar.hitpaw.com/tools/'],
    ]),
  ],
  [
    'br',
    new Map([
      ['homepage', 'https://online.hitpaw.com.br/'],
      ['editorPage', 'https://online.hitpaw.com.br/tools/'],
    ]),
  ],
  [
    'cn',
    new Map([
      ['homepage', 'https://online.hitpaw.com/'],
      ['editorPage', 'https://online.hitpaw.com/index.html'],
    ]),
  ],
  [
    'de',
    new Map([
      ['homepage', 'https://online.hitpaw.de/'],
      ['editorPage', 'https://online.hitpaw.de/tools/'],
    ]),
  ],
  [
    'es',
    new Map([
      ['homepage', 'https://online.hitpaw.es/'],
      ['editorPage', 'https://online.hitpaw.es/tools/'],
    ]),
  ],
  [
    'en',
    new Map([
      ['homepage', 'https://online.hitpaw.com/'],
      ['editorPage', 'https://online.hitpaw.com/tools/'],
    ]),
  ],
  [
    'fr',
    new Map([
      ['homepage', 'https://online.hitpaw.fr/'],
      ['editorPage', 'https://online.hitpaw.fr/tools/'],
    ]),
  ],
  [
    'id',
    new Map([
      ['homepage', 'https://online.hitpaw.id/'],
      ['editorPage', 'https://online.hitpaw.id/tools/'],
    ]),
  ],
  [
    'in',
    new Map([
      ['homepage', 'https://online.hitpaw.in/'],
      ['editorPage', 'https://online.hitpaw.in/tools/'],
    ]),
  ],
  [
    'it',
    new Map([
      ['homepage', 'https://online.hitpaw.it/'],
      ['editorPage', 'https://online.hitpaw.it/tools/'],
    ]),
  ],
  [
    'jp',
    new Map([
      ['homepage', 'https://online.hitpaw.jp/'],
      ['editorPage', 'https://online.hitpaw.jp/tools/'],
    ]),
  ],
  [
    'kr',
    new Map([
      ['homepage', 'https://online.hitpaw.kr/'],
      ['editorPage', 'https://online.hitpaw.kr/tools/'],
    ]),
  ],
  [
    'nl',
    new Map([
      ['homepage', 'https://online.hitpaw.nl/'],
      ['editorPage', 'https://online.hitpaw.nl/tools/'],
    ]),
  ],
  [
    'ru',
    new Map([
      ['homepage', 'https://online.hitpaw.ru/'],
      ['editorPage', 'https://online.hitpaw.ru/tools/'],
    ]),
  ],
  [
    'tr',
    new Map([
      ['homepage', 'https://tr.hitpaw.com/'],
      ['editorPage', 'https://tr.hitpaw.com/tools/'],
    ]),
  ],
  [
    'tw',
    new Map([
      ['homepage', 'https://online.hitpaw.com/'],
      ['editorPage', 'https://online.hitpaw.com/tools/'],
    ]),
  ],
]);

export default urlMap.get(Utils.getLanguage());
